module.exports = __webpack_public_path__ + "91bdd4c94b6a46896ef6161bf84ab077.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hair-ice-queen.png
// module id = 2691
// module chunks = 0